// extracted by mini-css-extract-plugin
export default {"tooltip":"Ro-z","sharingV2":"So-z","sharingIconsV2":"To-z","links":"Uo-z","link":"Vo-z","facebookV2":"Wo-z","twitterV2":"Xo-z","pinterestV2":"Yo-z"};